import { createSlice } from '@reduxjs/toolkit';
import { EmployeeState } from '../types/store.types';

const initialState: EmployeeState = {
  error: null,
  itemListGet: false,
  employeeList: [],
  payrollList: null,
  selectedDays: [],
  employeeDetails: {},
  payrollDetails: {},
  branches: [],
  selectedBranch: '',
  active: true,
  deductions: {
    deductions: [],
  },
  extraPay: {
    extra_pay: [],
    total_extra_pay_amount: 0,
  },
  deductionsLoading: false,
  employeeListLoading: false,
  payrollListLoading: false,
  compensation_Type: [],
  county: [],
  department: [],
  position_master: [],
  state_master: [],
  payrollPeriod: {
    success: false,
  },
  selectedpayrollPeriod: '',
  payrollReportData: {},
  selectedEmployee: 'All Employees',
  selectedPosition: 'All Position',
  payrollReportFillterdData: {},
};

interface EmployeeBranch {
  label: string;
  branchId: string;
}

interface EmployeeBranchInput {
  _id: string;
  name: string;
}

const transformBranches = (branches: EmployeeBranchInput[]): EmployeeBranch[] => {
  return branches.map((branch) => ({
    label: branch?.name,
    branchId: branch?._id,
  }));
};

export const employeeSlice = createSlice({
  name: 'employee/payroll',
  initialState,
  reducers: {
    setEmployeeListLoading: (state) => {
      state.employeeListLoading = true;
      state.error = null;
    },
    getEmployeeList: (state, action) => {
      state.employeeList = action.payload;
      state.employeeListLoading = false;
    },
    setPayrollListLoading: (state) => {
      state.payrollListLoading = true;
      state.error = null;
    },
    getPayrollList: (state, action) => {
      state.payrollList = action.payload;
      state.payrollListLoading = false;
    },
    getSelectedDate: (state, action) => {
      state.selectedDays = action.payload;
    },
    getEmployeeDetails: (state, action) => {
      state.employeeDetails = action.payload;
    },
    getPayrollDetails: (state, action) => {
      state.payrollDetails = action.payload;
    },
    getBranchList: (state, action) => {
      const branchListData = transformBranches(action?.payload);
      state.branches = branchListData.sort((a, b) => a.label.localeCompare(b.label));
    },
    handleSelectedBranch: (state, action) => {
      state.selectedBranch = action.payload;
    },
    handleSelectedEmployee: (state, action) => {
      state.selectedEmployee = action.payload;
    },
    handleSelectedPosition: (state, action) => {
      state.selectedPosition = action.payload;
    },
    handleSetActive: (state, action) => {
      state.active = action.payload;
    },
    getDeductions: (state, action) => {
      state.deductions = action.payload;
    },
    getExtaPay: (state, action) => {
      state.extraPay = action.payload;
    },
    getPayrollPeriod: (state, action) => {
      state.payrollPeriod = action.payload;
    },
    handleSelectedPayrollPeriod: (state, action) => {
      state.selectedpayrollPeriod = action.payload;
    },
    getListOfItems: (state, action) => {
      state.itemListGet = true;
      state.compensation_Type = action.payload?.compensation_Type || [];
      state.county = action.payload?.county || [];
      state.department = action.payload?.department || [];
      state.position_master = action.payload?.position_master || [];
      state.state_master = action.payload?.state_master || [];
    },
    getUpdateListById: (state, action) => {
      const {
        id,
        days_available,
        first_name,
        last_name,
        branch,
        contacts,
        employee_address,
        department,
        designation,
        compensation,
      } = action.payload;

      state.employeeList = state.employeeList.map((employee) => {
        if (employee._id === id) {
          return {
            ...employee,
            days_available: days_available || employee.days_available,
            first_name: first_name || employee.first_name,
            last_name: last_name || employee.last_name,
            branch: branch || employee.branch,
            contacts: contacts || employee.contacts,
            employee_address: employee_address || employee.employee_address,
            department: department || employee.department,
            designation: designation || employee.designation,
            compensation: compensation || employee.compensation,
          };
        }
        return employee;
      });
    },
    getPayrollReportData: (state, action) => {
      state.payrollReportData = action.payload;
    },
    getPayrollReportFillterdData: (state, action) => {
      state.payrollReportFillterdData = action.payload;
    },
  },
});

export const employeeActions = employeeSlice.actions;

export default employeeSlice.reducer;
